import { BASE_URL } from '../data/constants';

export default function Overview({ catalog, onSelect }) {
  const totalEndpoints = catalog.reduce((sum, g) => sum + g.endpoints.length, 0);

  return (
    <div className="overview">
      <h1>Definite Assurance API</h1>
      <p className="overview-lead">
        Reference documentation for the Definite Assurance motor insurance API &mdash; covering
        client &amp; intermediary onboarding, quoting, proposals, payments, extensions and
        certificate issuance.
      </p>

      <div className="overview-meta">
        <div>
          <span className="overview-meta-value">{totalEndpoints}</span>
          <span className="overview-meta-label">Endpoints</span>
        </div>
        <div>
          <span className="overview-meta-value">{catalog.length}</span>
          <span className="overview-meta-label">Categories</span>
        </div>
        <div>
          <span className="overview-meta-value">Basic Auth</span>
          <span className="overview-meta-label">Authentication</span>
        </div>
      </div>

      <div className="overview-baseurl">
        <span>Base URL</span>
        <code>{BASE_URL}</code>
      </div>

      <div className="overview-auth-note">
        <span className="lock-icon" aria-hidden="true">
          &#128274;
        </span>
        Every endpoint below requires HTTP Basic Authentication. Your credentials were shared with
        you separately and are never displayed in this portal.
      </div>

      <div className="overview-auth-note">
        <span className="lock-icon" aria-hidden="true">
          &#8505;
        </span>
        These are test (UAT) APIs. Production API endpoints and credentials will be provided on
        Go Live.
      </div>

      <h2 className="overview-subheading">Reference values</h2>
      <div className="overview-reference-grid">
        <div>
          <h3>Cover Periods / Payment Intervals</h3>
          <div className="params-table-wrap">
            <table className="params-table">
              <tbody>
                <tr>
                  <td>Monthly</td>
                </tr>
                <tr>
                  <td>Annually</td>
                </tr>
                <tr>
                  <td>2installments</td>
                </tr>
                <tr>
                  <td>3Installment</td>
                </tr>
                <tr>
                  <td>6Installments</td>
                </tr>
                <tr>
                  <td>9Installments</td>
                </tr>
                <tr>
                  <td>10Installments</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <h3>Payment Methods</h3>
          <div className="params-table-wrap">
            <table className="params-table">
              <thead>
                <tr>
                  <th>Value</th>
                  <th>Meaning</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <code>0</code>
                  </td>
                  <td>Already paid direct to paybill</td>
                </tr>
                <tr>
                  <td>
                    <code>1</code>
                  </td>
                  <td>STK Prompt on M-PESA</td>
                </tr>
                <tr>
                  <td>
                    <code>3</code>
                  </td>
                  <td>Wallet payment</td>
                </tr>
                <tr>
                  <td>
                    <code>4</code>
                  </td>
                  <td>Credit facility</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <h3>Transaction Types</h3>
          <div className="params-table-wrap">
            <table className="params-table">
              <thead>
                <tr>
                  <th>Value</th>
                  <th>Meaning</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <code>1</code>
                  </td>
                  <td>New Business</td>
                </tr>
                <tr>
                  <td>
                    <code>2</code>
                  </td>
                  <td>Extensions</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <h2 className="overview-subheading">Browse by category</h2>
      <div className="overview-grid">
        {catalog.map((group) => (
          <div className="overview-card" key={group.category}>
            <h3>{group.category}</h3>
            <ul>
              {group.endpoints.map((ep) => (
                <li key={ep.id}>
                  <button type="button" onClick={() => onSelect(ep.id)}>
                    <span className={`method-tag method-${ep.method.toLowerCase()}`}>
                      {ep.method}
                    </span>
                    {ep.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
